<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useGradeStore } from './stores/gradeStore'
import { useMaterialStore } from './stores/materialStore'
import ConfiguratorLayout from './components/configurator/ConfiguratorLayout.vue'
import ConfiguratorHeader from './components/configurator/ConfiguratorHeader.vue'
import ViewerArea from './components/configurator/ViewerArea.vue'
import ControlBar from './components/configurator/ControlBar.vue'
import ConfigurationTabs from './components/configurator/ConfigurationTabs.vue'

const gradeStore = useGradeStore()
const materialStore = useMaterialStore()

// État de la démo
const selectedGradeId = ref<string>('')

// Handlers d'événements du viewer
function handleAngleChange(angle: number) {
  console.log('Angle changed:', angle)
}

function handleLoadProgress(progress: number) {
  console.log('Load progress:', progress)
}

function handleLoadComplete() {
  console.log('Load complete')
}

// Initialisation
onMounted(async () => {
  try {
    // Charger la liste des grades
    await gradeStore.fetchGrades()

    // Sélectionner le premier grade par défaut si disponible
    if (gradeStore.grades.length > 0) {
      selectedGradeId.value = gradeStore.grades[0].item_id
      await loadGradeMaterials(selectedGradeId.value)
    }
  } catch (error) {
    console.error('Erreur lors de l\'initialisation:', error)
  }
})

// Charger les matériaux d'un grade
async function loadGradeMaterials(gradeId: string) {
  try {
    await materialStore.fetchMaterials(gradeId)
    gradeStore.setActiveGrade(gradeId)
  } catch (error) {
    console.error('Erreur lors du chargement des matériaux:', error)
  }
}
</script>

<template>
  <ConfiguratorLayout>
    <template #header>
      <ConfiguratorHeader />
    </template>

    <template #viewer>
      <ViewerArea
        @angle-change="handleAngleChange"
        @load-progress="handleLoadProgress"
        @load-complete="handleLoadComplete"
      />
    </template>

    <template #controls>
      <ControlBar />
    </template>

    <template #configuration>
      <ConfigurationTabs />
    </template>
  </ConfiguratorLayout>
</template>

<style scoped>
/* Layout principal */
#app {
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: var(--color-bg-body);
}
</style>